import React, { Component } from 'react';
import TarjetaFuturo from './pages/components/TarjetaFuturo'
import LoQueNecesitas from './pages/components/LoQueBuscas'
import AfiliarRec from './pages/components/AfiliarRecibir'
import Comisiones from './pages/components/comisiones'
import Servicios from './pages/components/Servicios'
import Descargas from './pages/components/descarga'
import Pasos from './pages/components/datosEmpresa'
import Banner from './pages/components/Banner'
import Footer from './pages/components/footer'
import translate from '../../translate'
import MyNav from './components/NavBar'
import './index.css'
import './landing2.css'
let sections

class Landing extends Component {
  constructor(props){
    super(props);
    this.state = {
      showTerms:this.props?.location?.state?.showTerms,
      showPrivacy:this.props?.location?.state?.showPrivacy,
      lan:localStorage.getItem('lan') ?localStorage.getItem('lan') :'es',
    }
    this.scrollTo = this.scrollTo.bind(this)
    this.changeLan = this.changeLan.bind(this)
    this.footerRef = React.createRef();
  }

  changeLan(lan){
    this.setState({ text: translate[lan].Landing.Content, lan:lan})
  }

  scrollTo(element){
    sections = window.document.querySelectorAll('.section-container');
      var elmntToView = window.document.getElementById(element);
      if(elmntToView)
        elmntToView.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
  }

  render() {
    return (
      <div className={'backgroundLI'}>
        <MyNav data={this.props} selected="/" changeLan={(e)=>this.changeLan(e)} scrollTo={this.scrollTo} />
        <Banner lan={this.state.lan} scrollTo={this.scrollTo} />
        <Servicios lan={this.state.lan} scrollTo={this.scrollTo} />
        <TarjetaFuturo lan={this.state.lan} scrollTo={this.scrollTo}/>
        <LoQueNecesitas lan={this.state.lan} scrollTo={this.scrollTo} />
        <Comisiones lan={this.state.lan} scrollTo={this.scrollTo} />
        <Pasos lan={this.state.lan} scrollTo={this.scrollTo} />
        <Descargas lan={this.state.lan} scrollTo={this.scrollTo}/>
        {/* <AfiliarRec lan={this.state.lan} scrollTo={this.scrollTo} /> */}
        <Footer lan={this.state.lan} scrollTo={this.scrollTo} showTerms={this.state.showTerms} showPrivacy={this.state.showPrivacy} />
      </div>
    );
  }
}

export default Landing
